<template>
  <div class="video-player-wrapper">
    <div v-if="loading" class="loading-overlay-live">
      <div class="spinner"></div>
    </div>
    <video ref="videoEl" autoplay playsinline class="native-video w-100 background-video" height="500"></video>
  </div>
</template>

<script>
import Hls from 'hls.js'

export default {
  name: 'PlayerComponent',
  props: [
    "cameraToken",
    "liveUrl",
    "mime",
    "startAt",
    "finishTimeVideo",
    "isLoading"
  ],
  data() {
    return {
      hls: null,
      mode: 'live',
      videoTimeout: null,
      streamStartTimeout: null,
      loading: false
    }
  },
  watch: {
    isLoading(isLoading) {
      this.loading = isLoading;
    }
  },
  methods: {
    onEnded() {
      console.log("Video terminou.", this.finishTimeVideo);
      if (this.$refs.videoEl && this.finishTimeVideo != null) {
        this.loading = true;
        this.$emit('video-ended', this.cameraToken, this.finishTimeVideo, 0);
      }
    },
    isHlsSource(src, mime) {
      return mime === 'application/x-mpegURL'
        || mime === 'application/vnd.apple.mpegurl'
        || /\.m3u8($|\?)/i.test(src);
    },
    clearVideoTimeout() {
      if (this.videoTimeout) {
        console.log("Cancelando timeout anterior");
        clearTimeout(this.videoTimeout);
        this.videoTimeout = null;
      }
    },
    clearStreamStartTimeout() {
      if (this.streamStartTimeout) {
        clearTimeout(this.streamStartTimeout);
        this.streamStartTimeout = null;
      }
    },
    destroyHls() {
      if (this.hls) {
        this.hls.destroy();
        this.hls = null;
      }

      this.clearStreamStartTimeout();
    },
    loadSource(src, mime) {
      this.loading = true;
      const videoEl = this.$refs.videoEl;

      if (!videoEl || !src) {
        this.loading = false;
        return;
      }

      this.clearVideoTimeout();
      this.destroyHls();

      const isHls = this.isHlsSource(src, mime);
      const canPlayNativeHls = videoEl.canPlayType('application/vnd.apple.mpegurl')
        || videoEl.canPlayType('application/x-mpegURL');

      if (isHls && Hls.isSupported()) {
        console.log("carregando fonte com hls.js");
        this.streamStartTimeout = setTimeout(() => {
          this.loading = false;
        }, 10000);

        this.hls = new Hls({
          lowLatencyMode: false,
          liveSyncDurationCount: 4,
          liveMaxLatencyDurationCount: 8,
          maxBufferLength: 30,
          backBufferLength: 10,
          maxLoadingDelay: 2.5,
          fragLoadingTimeOut: 10000,
          manifestLoadingTimeOut: 5000,
          levelLoadingTimeOut: 5000
        });

        this.hls.loadSource(src);
        this.hls.attachMedia(videoEl);
        this.hls.on(Hls.Events.MANIFEST_PARSED, () => {
          videoEl.play().catch(err => {
            console.warn("Erro ao dar play no HLS:", err);
            this.loading = false;
          });
        });
        this.hls.on(Hls.Events.FRAG_LOADED, () => {
          this.clearStreamStartTimeout();
          this.loading = false;
        });
        this.hls.on(Hls.Events.ERROR, (event, data) => {
          if (data.fatal) {
            console.error("Erro fatal no HLS:", data);

            if (data.type === Hls.ErrorTypes.NETWORK_ERROR) {
              this.loading = false;
              this.hls.startLoad();
              return;
            }

            if (data.type === Hls.ErrorTypes.MEDIA_ERROR) {
              this.loading = false;
              this.hls.recoverMediaError();
              return;
            }

            this.loading = false;
          }
        });

        return;
      }

      console.log("carregando fonte nativamente");

      videoEl.onloadedmetadata = () => {
        if (this.startAt && mime === 'video/mp4') {
          console.log("Avancando para", this.startAt, "segundos");
          videoEl.currentTime = this.startAt;
        }

        videoEl.play().then(() => {
          this.loading = false;
          console.log("Video iniciado com sucesso", videoEl.duration);

          this.clearVideoTimeout();

          if (videoEl.duration === Infinity) {
            console.log("Video infinito, nao definindo timeout");
            return;
          }

          const remainingTime = (videoEl.duration - videoEl.currentTime) * 1000;
          console.log("Tempo restante para o video terminar:", remainingTime, "ms");

          if (remainingTime > 0 && Number.isFinite(remainingTime)) {
            this.videoTimeout = setTimeout(() => {
              console.log("Timeout acionado, disparando evento ended");
              videoEl.dispatchEvent(new Event('ended'));
            }, remainingTime);
          }
        }).catch(err => {
          console.warn("Erro ao dar play no video:", err);
          this.loading = false;
        });
      };

      videoEl.onerror = () => {
        console.warn("Erro ao carregar fonte de video:", src);
        this.loading = false;
      };

      videoEl.src = src;
      videoEl.load();

      if (isHls && canPlayNativeHls) {
        videoEl.play().catch(() => {
          this.loading = false;
        });
      }
    },
    toLive() {
      if (this.mode !== 'live') {
        this.mode = 'live';
        this.loadSource(this.liveUrl, this.mime);
      }
    },
    toRecording() {
      if (this.mode !== 'recording') {
        this.mode = 'recording';
        this.loadSource(this.liveUrl, this.mime);
      }
    }
  },
  mounted() {
    console.log("montado agora", this.cameraToken, this.liveUrl, this.mime);
    this.loadSource(this.liveUrl, this.mime);
    this.$refs.videoEl.addEventListener('ended', this.onEnded);
  },
  beforeUnmount() {
    console.log("desmontando agora");
    this.clearVideoTimeout();
    this.destroyHls();
  }
}
</script>

<style scoped>
@import 'https://cdn.jsdelivr.net/npm/@vime/core@^5/themes/default.css';
.video-player-wrapper {
  height: 500px;
}
.player-header {
  display: flex;
  justify-content: center;
  gap: .5rem;
  margin-bottom: .5rem;
}
.player-header button {
  padding: .5rem 1rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
.player-header button.active {
  background: #2196f3;
  color: white;
}

.background-video{
  background-color: #000;
}

@media screen and (max-width: 767px) {
  .video-player-wrapper{
    height: clamp(210px, 31dvh, 280px) !important;
  }

  .video-player-wrapper video {
    height: clamp(210px, 31dvh, 280px) !important;
  }
}

.loading-overlay-live {
  position: fixed !important;
  top: 0px !important;
  left: 0px !important;
  z-index: 10 !important;
  width: 100% !important;
  height: 100% !important;
  background-color: rgba(0, 0, 0, 0.6) !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #ffffff80;
  border-top: 4px solid #fff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}
</style>
